module.exports = __webpack_public_path__ + "static/august-1-3d6477a0c016403d6bd39c76ab86f885.png";